import React, { useEffect, useState } from 'react';
import CustomStepper from '../../Components/Stepper';
import RequestorDetail from './Components/RequestorDetails/RequestorDetail';
import IndividualDetail from './Components/IndividualDetails/IndividualDetail';
import ReviewDetails from './Components/ReviewDetails/ReviewDetails';
import PaymentPage from './Components/PaymentPage/PaymentPage';
import { steps } from '../../Utils/Constants';

const StepperForm = () => {
  const [currentStep, setCurrentStep] = useState(0); // Example: Step 3 (Review)

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [currentStep]);

  return (
    <div className="w-full mt-12 max-w-[807px] flex flex-col items-center min-h-screen">
      <CustomStepper currentStep={currentStep} steps={steps} />
      <div className="mt-4 bg-white shadow-xl rounded-2xl w-full py-12 px-[103px]">
        {currentStep === 0 && <RequestorDetail setCurrentStep={setCurrentStep} />}
        {currentStep === 1 && <IndividualDetail setCurrentStep={setCurrentStep} />}
        {currentStep === 2 && <ReviewDetails setCurrentStep={setCurrentStep} />}
        {currentStep === 3 && <PaymentPage setCurrentStep={setCurrentStep} />}
      </div>
    </div>
  );
};

export default StepperForm;
